/**
 * Which home prompts to show. No scheduler imports: the iOS bundle loads this file.
 * At most two cards. Order is the yearly check-in, then the next local date,
 * then one question or interval offer.
 */

function selectHomePrompts({ hasCheckin, upcoming, action }) {
  const prompts = [];
  if (hasCheckin) prompts.push({ type: 'checkin' });
  if (upcoming && upcoming.due_date) prompts.push(Object.assign({ type: 'upcoming' }, upcoming));
  // One question at a time. The yearly check-in already asks something today.
  const questionToday = hasCheckin && action && action.type === 'question';
  if (!questionToday && action && action.type && action.type !== 'upcoming' && action.type !== 'checkin') {
    prompts.push(action);
  }
  return prompts.slice(0, 2);
}

module.exports = { selectHomePrompts };
